<template>
  <div id="app">
    <transition name="router-switch" mode="out-in">
      <!-- <router-view /> -->
      <div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"> </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"> </router-view>
      </div>
    </transition>
    <van-overlay
      z-index="2999"
      :show="$store.state.isLoadding"
      @click.stop
      class="loading-overlay"
      style="background: unset"
    >
      <div class="loadding-out">
        <van-loading class="all-loadding" type="spinner" vertical>
          加载中...
        </van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  created() {
	  console.log(111)
    // 检测更新
    // window.changeversion = this.checkUpdate;
  },
  methods: {
    checkUpdate(...arg) {
      let version = arg[0].toString().split("").join(".");
      this.$post({
        module: "Utils",
        interface: "1002",
        data: {
          platform: 1,
          version,
        },
      })
        .then((res) => {
          window.test.version(JSON.stringify(res));
        })
        .catch((err) => {
          console.log("检测更新失败", err);
        });
    },
  },
  watch: {
    $route(nVal) {
      console.log(nVal);
    },
  },
};
</script>

<style lang="less">
.search .el-select-dropdown__item.selected {
  color: #fd0212 !important;
}
@import "./css/public.css";
/** 过度动画 */
.router-switch-enter-active,
.router-switch-leave-active {
  transition: opacity 0.3s;
}
.router-switch-enter,
.router-switch-leave-to {
  opacity: 0;
}

/** 卡片打开关闭动画 */
.anim-simple-up-enter-active,
.anim-simple-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.anim-simple-up-enter,
.anim-simple-up-leave-to {
  opacity: 0;
  transform: translateY(-50%) scaleY(0.5);
}

body {
  margin: 0;
  overflow: scroll;
}

*::-webkit-scrollbar {
  display: none;
}

/* input::-webkit-input-placeholder {
  color: #808080;
  font-size: 14px;
} */
a {
  text-decoration: none;
  color: #666666;
}
input {
  background: transparent;
  outline: none;
  border: none;
  width: 100%;
}
.overText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
/* 页面最外层 */
#app {
  min-height: 100vh;
  background-color: white;
  color: #333;
  font-size: 16px;
}
/* Header 头 */
.app-header-vue,
.app-header-placeholder {
  /* background-color: rgb(49, 43, 43); */
  color: #000000;
  height: 40px;
}
/* 底部栏 */
.activeSpan {
  color: #fd0212;
}
.app-foot-bar {
  box-shadow: 0px -4px 6px 0px rgba(16, 16, 16, 0.02);
  background: #ffffff;
  color: #989191;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-overlay > .loadding-out {
  background-color: rgba(0, 0, 0, 0.7);
  width: 100px;
  height: 100px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-dialog {
  border-radius: 8px !important;
}
</style>
